import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _circle;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgGlovo = function SvgGlovo(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M24.244 13.354c0 .888-.457 2.13-1.273 3.575-.795 1.409-1.852 2.875-2.88 4.171-1.35 1.705-3.832 1.705-5.182 0-1.027-1.296-2.085-2.762-2.88-4.171-.816-1.445-1.273-2.687-1.273-3.575a6.744 6.744 0 0 1 13.488 0Z",
      stroke: "currentColor",
      strokeWidth: 2
    })), _circle || (_circle = /*#__PURE__*/_jsx("circle", {
      cx: 17.5,
      cy: 26.936,
      r: 1.455,
      stroke: "currentColor",
      strokeWidth: 2
    }))]
  }));
};
export default SvgGlovo;